import { Link } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa";
const ContentLayoutDetailsHeader = ({
  label,
  name,
  navigationLink,
  iconList,
}) => {
  return (
    <div className="stickyy mng-header">
      <div className="d-flex-align-cent gap-10">
        <Link to={navigationLink}>
          <p className="fs-22 black semi-bold header-nm">{label}</p>
        </Link>
        {name && <FaAngleRight className="fs-20 skBlue" />}
        {name ? (
          <p className="fs-22 black semi-bold line-height-20">{name}</p>
        ) : null}
      </div>
      <div className="d-flex-align-cent gap-20">
        {iconList?.map((item, index) => (
          <span
            className="icon-container"
            onClick={item?.handleClick}
            key={index}
          >
            {item.icon}
          </span>
        ))}
      </div>
    </div>
  );
};

export default ContentLayoutDetailsHeader;
